import { decode as base64_decode, encode as base64_encode } from 'base-64';
import RootStore from './RootStore';

import { postApi, baseURL } from '../components/Utility'
import config from "../config";

import {
  action,

  makeObservable,
  observable,

} from 'mobx';
import { message } from 'antd';
import { count } from 'd3';


class TravelReportStore {
  travelReport = []
  totalStartStopArray = []
  total = 0
  remaning_vehicleId = ""
  last_record_timestamp = ""
  loading = false
  rootStore
  loadingData = false
  pageSize = 0
  pythonReportMessage = false
  pythonReportErrorMessage = false

  constructor(rootStore) {
    makeObservable(this, {
      travelReport: observable,
      pageSize: observable,
      totalStartStopArray: observable,
      remaning_vehicleId: observable,
      last_record_timestamp: observable,
      total: observable,
      loading: observable,
      loadingData: observable,
      loadData: action,
      exportExcel: action,
      exportcsv: action,
      exportpdf: action,
      exportxml: action,
      exporttotalexcel: action,
      exporttotalpdf: action,
      totalStartStopReport: action,
      pythonReportMessage: observable,
      pythonReportErrorMessage: observable
    });
    this.rootStore = rootStore;

  }

  async loadData({ companyId, offset, limit, vehicleId, fromDate, toDate, interval, pageNo }) {
    this.loading = true;
    // console.log("Travel Report",interval,pageNo)
    var postData = { "companyId": companyId, "vehicleId": vehicleId, "fromDate": fromDate, "toDate": toDate, "interval": interval, "offset": offset, "limit": limit, "page": pageNo }

    if (config.pythonReport === 1) {
      // postData.companyId=10166
      // postData.vehicleId=[26375]
      postData.tablename = "awtltrack.fm_mt90"
      if (offset === 0) {
        postData.last_record_timestamp = ""
        postData.remaning_vehicleId = ""
      } else {
        postData.last_record_timestamp = this.last_record_timestamp
        postData.remaning_vehicleId = this.remaning_vehicleId
      }

      var response = await postApi.getClient('report').post("/report/travelreportnew", postData);
      this.total = 500

    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi.getClient().post("index.php?c=vehicle&a=startstop", "postData=" + base64Input);
      this.total = parseInt(response?.data?.data?.TotalCount);
    }

    if (config.pythonReport === 1) {
      this.last_record_timestamp = response?.data?.data?.last_record_timestamp
      this.remaning_vehicleId = response?.data?.data?.remaning_vehicleId
    }

    // var totalLength = response?.data?.data?.startStopData.length

    // if(totalLength < 50){
    //   this.total = totalLength
    // }else{
    //   this.total = 500
    // }
    // console.log(response?.data?.data?.startStopData.length);
    this.travelReport = response?.data?.data?.startStopData
    this.pageSize = this.travelReport?.length
    // console.log("travel " ,response?.data?.data?.startStopData)
    this.loading = false;
  }

  async totalStartStopReport({ offset, limit, companyId, fromDate, toDate, vehicleId, interval }) {
    if (config.pythonReport !== 1) {
      this.loadingData = true
      console.log("vehicletotalPerformance")
      var postData = { "companyId": companyId, "vehicleId": vehicleId, "fromDate": fromDate, "toDate": toDate, interval: interval, offset: offset, limit: limit }
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi.getClient().post("index.php?c=vehicle&a=totalStartStopRep", "postData=" + base64Input);
      this.totalStartStopArray = response?.data?.data
      this.total = parseInt(response?.data?.data?.TotalCount);
      this.loadingData = false;
    }
  }

  async exportExcel(getData) {
    // console.log("getData", getData);
    if (config.pythonReport === 1) {

      getData = { ...getData, language: "english" }
      // getData = { ...getData, companyId: 10166 }
      // getData = { ...getData, vehicleId: [26375] }
      try {

        await postApi.getClient("report").post("/report/travelnew/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
        // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);

      } catch (error) {
        this.pythonReportErrorMessage = true;
        // message.error("Failed to download the report. Please try again.")
      }

    } else {

      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportstartstopexcel&cid=" +
        getData.companyId +
        "&vid=" +
        getData.vehicleId +
        "&userId=" +
        getData.userId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }

  }

  async exportcsv(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportstartstopcsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&int=" +
      getData.interval +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }

  async exportpdf(getData) {

    if (config.pythonReport === 1) {

      getData = { ...getData, language: "english" }
      // getData = { ...getData, companyId: 10166 }
      // getData = { ...getData, vehicleId: [26375] }
      try {

        await postApi.getClient("report").post("/report/travelnew/download/pdf", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
        // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);

      } catch (error) {
        this.pythonReportErrorMessage = true;
        // message.error("Failed to download the report. Please try again.")
      }

    } else {

      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportstartstoppdf&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }

  }

  async exportxml(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportstartstopxml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&int=" +
      getData.interval +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
  async exporttotalexcel(getData) {

    if (config.pythonReport === 1) {

      getData = { ...getData, language: "english" }
      // getData = { ...getData, companyId: 10166 }
      // getData = { ...getData, vehicleId: [26375] }
      try {

        await postApi.getClient("report").post("/report/travelnewtotal/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
        // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);

      } catch (error) {
        this.pythonReportErrorMessage = true;
        // message.error("Failed to download the report. Please try again.")
      }

    } else {

      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportTotalstartstopexcel&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }

  }
  async exporttotalpdf(getData) {

    if (config.pythonReport === 1) {
      getData = { ...getData, language: "english" }
      // getData = { ...getData, companyId: 10166 }
      // getData = { ...getData, vehicleId: [26375] }
      try {

        await postApi.getClient("report").post("/report/travelnewtotal/download/pdf", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
        // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);

      } catch (error) {
        this.pythonReportErrorMessage = true;
        // message.error("Failed to download the report. Please try again.")
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportTotalstartstopPdf&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }

  }

}

export default TravelReportStore;
